import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/categories/actions';
import CategoryItem from './CategoryItem';
import { Page } from 'components/Page';


class CategoryPage extends Component {
  state = {  };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.fetchCategories();
  }

  renderCategories() {
    return _.map(this.props.categories, (category, key) => {
      return <CategoryItem key={key} id={key} category={category} />
    });
  }
  
  render() {
    return (
      <Page ready={!this.props.pending} className="Categories">
        <h1>Kanaler</h1>
        <div className="Page_Grid">
          {this.renderCategories()}
        </div>        
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return { 
    categories: state.categories.list.data, 
    pending: state.categories.list.pending, 
  };
}

export default connect(mapStateToProps, actions)(CategoryPage)

  



// WEBPACK FOOTER //
// ./src/pages/channels/Categories.jsx